export const UPDATE_USER_PROFILE = 'USER::UPDATE_USER_PROFILE'
